import { SetGetViewKeys  } from './thunk/setGetViewKeys';
import {SetPostCreateKeys} from './thunk/setPostCreateKeys';

export const Thunks = {
    SetGetViewKeys,
    SetPostCreateKeys

}